import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Renderer2, HostListener } from '@angular/core';

@Component({
  selector: 'app-search-results-popover',
  templateUrl: './search-results-popover.component.html',
  styleUrls: ['./search-results-popover.component.scss'],
})
export class SearchResultsPopoverComponent implements OnInit {

  @Input() users: any[];
  @Input() isCustomPopoverOpen: boolean;
  @Output() userSelected = new EventEmitter<any>();
  @Output() searchAreaSelected = new EventEmitter<any>();

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    console.log('filteredUsers', this.users);
  }

  selectUser(user: any, index: any) {
    this.userSelected.emit(user);
    this.searchAreaSelected.emit(index);
  }

  onPopoverClick(event: Event) {
    // Prevent the click event from closing the popover
    event.stopPropagation();
  }

}
